<div class="main-content-wrapper">
    <div class="main-content">
        <div style="font-size: 18px;">{{'Direct Document Retrieval page'}} </div>
        <div class="topContent">
            <div class="cnt left">
                <div class="">
                    <p><strong>Batch Type:</strong> {{docDetails.batchType}}</p>
                </div>
                <div class="">
                    <p><strong>Batch ID:</strong> {{docDetails.batchId}}</p>
                </div>
            </div>
        </div>
        <div class="content-box">
            <div class="left solid-border menu-tabs-content">
                <div class="document-view">
                    <ul>
                        <li *ngFor="let Document of docDetails?.documents">
                            {{'Document Id: '}} {{Document.documentId}}
                            <div>
                                <ul>
                                    <li *ngFor="let attachment of Document?.attachments">
                                        <div>
                                            <a [href]="attachment.documentLink + '/' + attachment.imageId"
                                                target="_blank"> {{attachment.fileName}} </a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>